// ============================================
// CLIENTES.JS — Gestión completa de clientes
// ============================================
import React, { useState, useEffect, useMemo } from 'react';
import { useBorradorCampos, AvisoRescate } from './utils/borradorFormulario';
import { OPC_DINERO } from './utils/dinero';

const PP = "'Poppins', sans-serif";
const COLOR_PRINCIPAL = '#5c9adb';
const COLOR_OSCURO = '#2f5f9e';
const COLOR_FONDO = '#f3f4f4';
const COLOR_GRIS = '#4e5357';
const COLOR_GRIS_CLARO = '#8a8f95';
const COLOR_VERDE = '#5cd4b0';
const COLOR_ROJO = '#e05c5c';

const KEY_CLIENTES = 'beep_clientes';

const GIROS = {
  comercio:  { label: 'Comercio',   color: '#5c9adb' },
  industria: { label: 'Industria',  color: '#9b59b6' },
  servicios: { label: 'Servicios',  color: '#5cd4b0' },
  gobierno:  { label: 'Gobierno',   color: '#2f5f9e' },
  educacion: { label: 'Educación',  color: '#f4a261' },
  salud:     { label: 'Salud',      color: '#e05c5c' },
  otro:      { label: 'Otro',       color: '#8a8f95' },
};
const TAMANOS = {
  micro:    { label: 'Micro' },
  pequena:  { label: 'Pequeña' },
  mediana:  { label: 'Mediana' },
  grande:   { label: 'Grande' },
};
const ESTADOS = {
  activo:    { label: 'Activo',    color: '#1D9E75', bg: '#e8faf5' },
  inactivo:  { label: 'Inactivo',  color: '#9a8300', bg: '#fffbe6' },
  prospecto: { label: 'Prospecto', color: '#5c9adb', bg: '#eaf2fb' },
};

function CLIENTES_DEMO() {
  const ahora = Date.now();
  return [
    {
      id: 1, folio: 'CLI-001', tipo: 'empresa',
      nombre: 'Bodegas Alianza',
      razonSocial: 'Bodegas Alianza S.A. de C.V.',
      rfc: '', giro: 'comercio', tamano: 'mediana', estado: 'activo',
      sucursales: [
        { id: 1, nombre: 'Matriz', direccion: 'Av. Principal 123, CDMX', contacto: '', telefono: '', equiposInstalados: [], notas: '' },
        { id: 2, nombre: 'Sucursal Norte', direccion: 'Calle Norte 456, CDMX', contacto: '', telefono: '', equiposInstalados: [], notas: '' },
      ],
      contactoPrincipal: { nombre: 'José Antonio Gómez', cargo: 'Gerente General', telefono: '55 1234 5678', correo: 'jagomez@almasa.com.mx', whatsapp: '5512345678' },
      contactosAdicionales: [],
      direccion: { calle: '', colonia: '', ciudad: '', estado: '', cp: '' },
      equiposInstalados: [], serviciosHistorial: [], proyectosHistorial: [], cotizacionesHistorial: [],
      notas: [], etiquetas: [],
      fechaAlta: new Date(ahora - 365 * 86400000).toISOString(),
      ultimaActividad: new Date(ahora - 2 * 86400000).toISOString(),
      vendedorAsignado: null, montoTotalFacturado: 350000,
      polizaActiva: true, garantiaActiva: true, calificacionPromedio: null,
    },
    {
      id: 2, folio: 'CLI-002', tipo: 'empresa',
      nombre: 'Farma Plus', razonSocial: 'Farma Plus S.A. de C.V.',
      rfc: '', giro: 'salud', tamano: 'pequena', estado: 'activo',
      sucursales: [
        { id: 1, nombre: 'Matriz', direccion: 'Insurgentes Sur 789, CDMX', contacto: '', telefono: '', equiposInstalados: [], notas: '' },
        { id: 2, nombre: 'Polanco', direccion: 'Presidente Masaryk 100, CDMX', contacto: '', telefono: '', equiposInstalados: [], notas: '' },
      ],
      contactoPrincipal: { nombre: 'Carlos Selvas', cargo: 'Director TI', telefono: '55 9876 5432', correo: 'cselvas@farmaplus.com', whatsapp: '5598765432' },
      contactosAdicionales: [],
      direccion: { calle: '', colonia: '', ciudad: '', estado: '', cp: '' },
      equiposInstalados: [], serviciosHistorial: [], proyectosHistorial: [], cotizacionesHistorial: [],
      notas: [], etiquetas: [],
      fechaAlta: new Date(ahora - 200 * 86400000).toISOString(),
      ultimaActividad: new Date(ahora - 5 * 86400000).toISOString(),
      vendedorAsignado: null, montoTotalFacturado: 85000,
      polizaActiva: false, garantiaActiva: true, calificacionPromedio: null,
    },
    {
      id: 3, folio: 'CLI-003', tipo: 'persona_fisica',
      nombre: 'Miguel Angel Mercado', razonSocial: '',
      rfc: '', giro: 'comercio', tamano: 'micro', estado: 'activo',
      sucursales: [{ id: 1, nombre: 'Local 60', direccion: 'Mercado San Fernando, Local 60, Tlalpan', contacto: '', telefono: '', equiposInstalados: [], notas: '' }],
      contactoPrincipal: { nombre: 'Miguel Angel Mercado', cargo: 'Dueño', telefono: '55 5555 5555', correo: 'javierhga@gmail.com', whatsapp: '5555555555' },
      contactosAdicionales: [],
      direccion: { calle: '', colonia: '', ciudad: '', estado: '', cp: '' },
      equiposInstalados: [], serviciosHistorial: [], proyectosHistorial: [], cotizacionesHistorial: [],
      notas: [], etiquetas: [],
      fechaAlta: new Date(ahora - 90 * 86400000).toISOString(),
      ultimaActividad: new Date(ahora - 10 * 86400000).toISOString(),
      vendedorAsignado: null, montoTotalFacturado: 13339,
      polizaActiva: false, garantiaActiva: false, calificacionPromedio: null,
    },
    {
      id: 4, folio: 'CLI-004', tipo: 'empresa',
      nombre: 'Abarrotes La Manita', razonSocial: 'Almasa S.A. de C.V.',
      rfc: '', giro: 'comercio', tamano: 'mediana', estado: 'activo',
      sucursales: [
        { id: 1, nombre: 'Local 1', direccion: 'Av. Insurgentes 234, CDMX', contacto: '', telefono: '', equiposInstalados: [], notas: '' },
        { id: 2, nombre: 'Local 2', direccion: 'Calle Reforma 567, CDMX', contacto: '', telefono: '', equiposInstalados: [], notas: '' },
      ],
      contactoPrincipal: { nombre: 'José Manuel González', cargo: 'Gerente Operativo', telefono: '55 4444 4444', correo: 'jgonzalez@almasa.com.mx', whatsapp: '5544444444' },
      contactosAdicionales: [],
      direccion: { calle: '', colonia: '', ciudad: '', estado: '', cp: '' },
      equiposInstalados: [], serviciosHistorial: [], proyectosHistorial: [], cotizacionesHistorial: [],
      notas: [], etiquetas: [],
      fechaAlta: new Date(ahora - 500 * 86400000).toISOString(),
      ultimaActividad: new Date().toISOString(),
      vendedorAsignado: null, montoTotalFacturado: 175270,
      polizaActiva: true, garantiaActiva: true, calificacionPromedio: null,
    },
  ];
}

function cargarClientes() {
  try {
    const raw = localStorage.getItem(KEY_CLIENTES);
    if (raw) return JSON.parse(raw);
  } catch {}
  const seed = CLIENTES_DEMO();
  try { localStorage.setItem(KEY_CLIENTES, JSON.stringify(seed)); } catch {}
  return seed;
}
function guardarClientesLS(arr) {
  try { localStorage.setItem(KEY_CLIENTES, JSON.stringify(arr)); } catch {}
}

function iniciales(nombre) {
  return (nombre || '?').split(' ').filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');
}
function siguienteFolio(arr) {
  return `CLI-${String(arr.length + 1).padStart(3, '0')}`;
}
function fechaCorta(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return '—'; }
}
function diasDesde(iso) {
  if (!iso) return null;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

// ============================================
// COMPONENTE PRINCIPAL
// ============================================
function Clientes({ pestana, esCelular }) {
  const [clientes, setClientes] = useState(cargarClientes);
  const [tab, setTab] = useState(pestana || 'empresas');
  const [busqueda, setBusqueda] = useState('');
  const [filtroGiro, setFiltroGiro] = useState('todos');
  const [modal, setModal] = useState(null);
  const [detalle, setDetalle] = useState(null);

  useEffect(() => { guardarClientesLS(clientes); }, [clientes]);
  useEffect(() => { if (pestana) setTab(pestana); }, [pestana]);

  const filtrados = useMemo(() => {
    let arr = clientes;
    if (tab === 'empresas') arr = arr.filter(c => c.tipo === 'empresa');
    else if (tab === 'contratos') arr = arr.filter(c => c.polizaActiva);
    if (filtroGiro !== 'todos') arr = arr.filter(c => c.giro === filtroGiro);
    if (busqueda) {
      const q = busqueda.toLowerCase();
      arr = arr.filter(c =>
        (c.nombre || '').toLowerCase().includes(q) ||
        (c.razonSocial || '').toLowerCase().includes(q) ||
        (c.contactoPrincipal?.nombre || '').toLowerCase().includes(q)
      );
    }
    return arr;
  }, [clientes, tab, filtroGiro, busqueda]);

  // Para pestaña contactos: aplanar todos los contactos
  const contactos = useMemo(() => {
    const list = [];
    clientes.forEach(c => {
      if (c.contactoPrincipal?.nombre) {
        list.push({ ...c.contactoPrincipal, cliente: c.nombre, clienteId: c.id, clienteGiro: c.giro, principal: true });
      }
      (c.contactosAdicionales || []).forEach(co => {
        list.push({ ...co, cliente: c.nombre, clienteId: c.id, clienteGiro: c.giro, principal: false });
      });
    });
    if (busqueda) {
      const q = busqueda.toLowerCase();
      return list.filter(c => c.nombre.toLowerCase().includes(q) || (c.cliente || '').toLowerCase().includes(q));
    }
    return list;
  }, [clientes, busqueda]);

  const crearCliente = (data) => {
    const nuevo = {
      id: Date.now(),
      folio: siguienteFolio(clientes),
      ...data,
      sucursales: [], contactosAdicionales: [],
      equiposInstalados: [], serviciosHistorial: [], proyectosHistorial: [], cotizacionesHistorial: [],
      notas: [], etiquetas: [],
      fechaAlta: new Date().toISOString(),
      ultimaActividad: new Date().toISOString(),
      vendedorAsignado: null, montoTotalFacturado: 0,
      polizaActiva: false, garantiaActiva: false, calificacionPromedio: null,
    };
    setClientes([nuevo, ...clientes]);
    setModal(null);
  };

  const actualizarCliente = (id, cambios) => {
    setClientes(prev => prev.map(c => c.id === id ? { ...c, ...cambios } : c));
  };

  const tarjetaCard = { background: '#fff', borderRadius: 14, padding: esCelular ? 12 : 18, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' };
  const inputBase = { padding: '10px 12px', borderRadius: 10, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 13, outline: 'none', background: '#fff', boxSizing: 'border-box' };
  const btnPrimario = { padding: '10px 18px', background: COLOR_PRINCIPAL, color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontSize: 13, fontWeight: 700, cursor: 'pointer' };

  const tabs = [
    { id: 'empresas', label: 'Empresas' },
    { id: 'contactos', label: 'Contactos' },
    { id: 'contratos', label: 'Contratos' },
  ];

  if (detalle) {
    return (
      <DetalleCliente
        cliente={clientes.find(c => c.id === detalle.id) || detalle}
        esCelular={esCelular}
        onCerrar={() => setDetalle(null)}
        onActualizar={(cambios) => actualizarCliente(detalle.id, cambios)}
      />
    );
  }

  return (
    <div style={{ fontFamily: PP, display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: esCelular ? 20 : 24, fontWeight: 800, color: COLOR_GRIS }}>🏢 Clientes</div>
          <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginTop: 4 }}>
            {clientes.length} registrados · {clientes.filter(c => c.estado === 'activo').length} activos
          </div>
        </div>
        <button onClick={() => setModal({ modo: 'crear' })} style={btnPrimario}>+ Nuevo cliente</button>
      </div>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              padding: '8px 18px', borderRadius: 12,
              background: tab === t.id ? COLOR_PRINCIPAL : '#fff',
              color: tab === t.id ? '#fff' : COLOR_OSCURO,
              border: `1.5px solid ${COLOR_PRINCIPAL}`,
              fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: PP,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={tarjetaCard}>
        <input
          type="text"
          placeholder="🔍 Buscar..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          style={{ ...inputBase, width: '100%', marginBottom: tab !== 'contactos' ? 10 : 0 }}
        />
        {tab !== 'contactos' && (
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            <PillFiltro activo={filtroGiro === 'todos'} onClick={() => setFiltroGiro('todos')} color={COLOR_OSCURO}>Todos</PillFiltro>
            {Object.entries(GIROS).map(([k, info]) => (
              <PillFiltro key={k} activo={filtroGiro === k} onClick={() => setFiltroGiro(k)} color={info.color}>
                {info.label}
              </PillFiltro>
            ))}
          </div>
        )}
      </div>

      {tab === 'contactos' ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {contactos.length === 0 ? (
            <div style={{ ...tarjetaCard, textAlign: 'center', padding: 40, color: COLOR_GRIS_CLARO, fontSize: 13 }}>
              No hay contactos.
            </div>
          ) : contactos.map((c, i) => (
            <TarjetaContacto key={i} contacto={c} onAbrir={() => setDetalle(clientes.find(x => x.id === c.clienteId))} />
          ))}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {filtrados.length === 0 ? (
            <div style={{ ...tarjetaCard, textAlign: 'center', padding: 40, color: COLOR_GRIS_CLARO, fontSize: 13 }}>
              No hay clientes en esta vista.
            </div>
          ) : filtrados.map(c => (
            <TarjetaCliente key={c.id} cliente={c} esCelular={esCelular} onAbrir={() => setDetalle(c)} />
          ))}
        </div>
      )}

      {modal?.modo === 'crear' && (
        <ModalNuevoCliente
          onCrear={crearCliente}
          onCerrar={() => setModal(null)}
        />
      )}
    </div>
  );
}

function PillFiltro({ activo, onClick, color, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '6px 12px', borderRadius: 14,
        background: activo ? color : '#fff',
        color: activo ? '#fff' : color,
        border: `1.5px solid ${color}`,
        fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
      }}
    >
      {children}
    </button>
  );
}

// ============================================
// TARJETA CLIENTE
// ============================================
function TarjetaCliente({ cliente, esCelular, onAbrir }) {
  const giro = GIROS[cliente.giro] || GIROS.otro;
  const estado = ESTADOS[cliente.estado] || ESTADOS.activo;
  const dias = diasDesde(cliente.ultimaActividad);

  return (
    <div
      onClick={onAbrir}
      style={{
        background: '#fff', borderRadius: 12,
        padding: esCelular ? 12 : 16,
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
        cursor: 'pointer', display: 'flex', gap: 12,
      }}
    >
      <div style={{
        width: 50, height: 50, borderRadius: '50%',
        background: giro.color, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 16, fontWeight: 800, fontFamily: PP, flexShrink: 0,
      }}>
        {iniciales(cliente.nombre)}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8, flexWrap: 'wrap' }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_GRIS, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {cliente.nombre}
            </div>
            {cliente.razonSocial && (
              <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {cliente.razonSocial}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
            {cliente.polizaActiva && <span title="Póliza activa" style={{ fontSize: 14 }}>📜</span>}
            {cliente.garantiaActiva && <span title="Garantía activa" style={{ fontSize: 14 }}>🛡️</span>}
            <span style={{ fontSize: 10, fontWeight: 700, background: estado.bg, color: estado.color, padding: '3px 10px', borderRadius: 12 }}>
              {estado.label}
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 10, fontWeight: 700, background: giro.color + '22', color: giro.color, padding: '3px 8px', borderRadius: 10 }}>
            {giro.label}
          </span>
          <span style={{ fontSize: 10, color: COLOR_GRIS_CLARO, padding: '3px 0' }}>
            🏪 {cliente.sucursales?.length || 0} sucursal(es)
          </span>
        </div>
        {cliente.contactoPrincipal?.nombre && (
          <div style={{ fontSize: 11, color: COLOR_GRIS, marginTop: 6 }}>
            👤 {cliente.contactoPrincipal.nombre}
            {cliente.contactoPrincipal.telefono && ` · 📞 ${cliente.contactoPrincipal.telefono}`}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, fontSize: 11 }}>
          <span style={{ color: COLOR_GRIS_CLARO }}>
            {dias === null ? '' : dias === 0 ? 'Hoy' : `Hace ${dias}d`}
          </span>
          <span style={{ color: COLOR_OSCURO, fontWeight: 700 }}>
            ${(cliente.montoTotalFacturado || 0).toLocaleString('es-MX', OPC_DINERO)}
          </span>
        </div>
      </div>
    </div>
  );
}

// ============================================
// TARJETA CONTACTO
// ============================================
function TarjetaContacto({ contacto, onAbrir }) {
  const giro = GIROS[contacto.clienteGiro] || GIROS.otro;
  return (
    <div
      onClick={onAbrir}
      style={{
        background: '#fff', borderRadius: 12, padding: 12,
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
        cursor: 'pointer', display: 'flex', gap: 12, alignItems: 'center',
      }}
    >
      <div style={{
        width: 40, height: 40, borderRadius: '50%',
        background: giro.color, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 13, fontWeight: 800, flexShrink: 0,
      }}>
        {iniciales(contacto.nombre)}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: COLOR_GRIS }}>{contacto.nombre}</div>
        <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>
          {contacto.cargo && `${contacto.cargo} · `}{contacto.cliente}
        </div>
        <div style={{ fontSize: 11, color: COLOR_GRIS, marginTop: 2 }}>
          {contacto.telefono && `📞 ${contacto.telefono}`}
          {contacto.correo && ` · ✉ ${contacto.correo}`}
        </div>
      </div>
      {contacto.principal && (
        <span style={{ fontSize: 9, fontWeight: 700, background: COLOR_PRINCIPAL + '22', color: COLOR_OSCURO, padding: '2px 8px', borderRadius: 10 }}>
          PRINCIPAL
        </span>
      )}
    </div>
  );
}

// ============================================
// MODAL NUEVO CLIENTE (3 pasos)
// ============================================
// Valores con los que ABRE el formulario: referencia para saber si hay algo capturado de verdad.
const INICIAL_CLIENTE = { tipo: 'empresa', nombre: '', razonSocial: '', rfc: '', giro: 'comercio',
  tamano: 'pequena', estado: 'activo', contactoNombre: '', contactoCargo: '', contactoTel: '',
  contactoCorreo: '', contactoWA: '', calle: '', colonia: '', ciudad: '' };

function ModalNuevoCliente({ onCrear, onCerrar }) {
  const [paso, setPaso] = useState(1);
  const [tipo, setTipo] = useState('empresa');
  const [nombre, setNombre] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [rfc, setRfc] = useState('');
  const [giro, setGiro] = useState('comercio');
  const [tamano, setTamano] = useState('pequena');
  const [estado, setEstado] = useState('activo');
  const [contactoNombre, setContactoNombre] = useState('');
  const [contactoCargo, setContactoCargo] = useState('');
  const [contactoTel, setContactoTel] = useState('');
  const [contactoCorreo, setContactoCorreo] = useState('');
  const [contactoWA, setContactoWA] = useState('');
  const [calle, setCalle] = useState('');
  const [colonia, setColonia] = useState('');
  const [ciudad, setCiudad] = useState('');

  // Borrador local: el mismo mecanismo de Editar expediente (clave usuario:pantalla:registro)
  const camposBorrador = { tipo, nombre, razonSocial, rfc, giro, tamano, estado, contactoNombre, contactoCargo, contactoTel, contactoCorreo, contactoWA, calle, colonia, ciudad };
  const aplicarBorrador = (d) => {
    const set = { tipo: setTipo, nombre: setNombre, razonSocial: setRazonSocial, rfc: setRfc, giro: setGiro,
      tamano: setTamano, estado: setEstado, contactoNombre: setContactoNombre, contactoCargo: setContactoCargo,
      contactoTel: setContactoTel, contactoCorreo: setContactoCorreo, contactoWA: setContactoWA,
      calle: setCalle, colonia: setColonia, ciudad: setCiudad };
    Object.keys(set).forEach(k => { if (d[k] !== undefined) set[k](d[k]); });
  };
  const bor = useBorradorCampos('clientes', 'nuevo', camposBorrador, aplicarBorrador, { iniciales: INICIAL_CLIENTE });

  const inputBase = { padding: '10px 12px', borderRadius: 10, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' };
  const labelStyle = { fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 700, marginBottom: 4, display: 'block', textTransform: 'uppercase' };

  const puede1 = nombre.trim();
  const puede2 = contactoNombre.trim();

  const submit = () => {
    onCrear({
      tipo, nombre: nombre.trim(), razonSocial: razonSocial.trim(), rfc, giro, tamano, estado,
      contactoPrincipal: {
        nombre: contactoNombre.trim(), cargo: contactoCargo,
        telefono: contactoTel, correo: contactoCorreo, whatsapp: contactoWA,
      },
      direccion: { calle, colonia, ciudad, estado: '', cp: '' },
    });
    bor.limpiar(); // creado: el borrador ya no hace falta
  };

  return (
    <div style={overlay}>
      <div style={{ ...modalCard, maxWidth: 500 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: COLOR_OSCURO }}>Nuevo cliente</div>
          <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>Paso {paso} de 3</div>
        </div>

        <div style={{ display: 'flex', gap: 4, marginBottom: 18 }}>
          {[1, 2, 3].map(n => (
            <div key={n} style={{ flex: 1, height: 4, borderRadius: 4, background: n <= paso ? COLOR_PRINCIPAL : '#e6e9ee' }} />
          ))}
        </div>

        <AvisoRescate bor={bor} />

        {paso === 1 && (
          <div>
            <label style={labelStyle}>Tipo</label>
            <div style={{ display: 'flex', gap: 6 }}>
              {[{ k: 'empresa', l: '🏢 Empresa' }, { k: 'persona_fisica', l: '👤 Persona física' }].map(t => (
                <button
                  key={t.k}
                  onClick={() => setTipo(t.k)}
                  style={{
                    flex: 1, padding: 12, borderRadius: 10,
                    background: tipo === t.k ? COLOR_PRINCIPAL : '#fff',
                    color: tipo === t.k ? '#fff' : COLOR_OSCURO,
                    border: `1.5px solid ${COLOR_PRINCIPAL}`,
                    fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: PP,
                  }}
                >
                  {t.l}
                </button>
              ))}
            </div>

            <label style={{ ...labelStyle, marginTop: 12 }}>Nombre comercial *</label>
            <input value={nombre} onChange={(e) => setNombre(e.target.value)} style={inputBase} placeholder="Ej: Bodegas Alianza" />

            {tipo === 'empresa' && (
              <>
                <label style={{ ...labelStyle, marginTop: 12 }}>Razón social</label>
                <input value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} style={inputBase} placeholder="S.A. de C.V." />
              </>
            )}

            <label style={{ ...labelStyle, marginTop: 12 }}>RFC</label>
            <input value={rfc} onChange={(e) => setRfc(e.target.value.toUpperCase())} style={inputBase} placeholder="XXXX000000XXX" />

            <label style={{ ...labelStyle, marginTop: 12 }}>Giro</label>
            <select value={giro} onChange={(e) => setGiro(e.target.value)} style={inputBase}>
              {Object.entries(GIROS).map(([k, info]) => <option key={k} value={k}>{info.label}</option>)}
            </select>

            <label style={{ ...labelStyle, marginTop: 12 }}>Tamaño</label>
            <select value={tamano} onChange={(e) => setTamano(e.target.value)} style={inputBase}>
              {Object.entries(TAMANOS).map(([k, info]) => <option key={k} value={k}>{info.label}</option>)}
            </select>

            <label style={{ ...labelStyle, marginTop: 12 }}>Estado</label>
            <div style={{ display: 'flex', gap: 6 }}>
              {[{ k: 'activo', l: 'Activo' }, { k: 'prospecto', l: 'Prospecto' }].map(e => (
                <button
                  key={e.k}
                  onClick={() => setEstado(e.k)}
                  style={{
                    flex: 1, padding: 10, borderRadius: 10,
                    background: estado === e.k ? COLOR_PRINCIPAL : '#fff',
                    color: estado === e.k ? '#fff' : COLOR_OSCURO,
                    border: `1.5px solid ${COLOR_PRINCIPAL}`,
                    fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: PP,
                  }}
                >
                  {e.l}
                </button>
              ))}
            </div>
          </div>
        )}

        {paso === 2 && (
          <div>
            <label style={labelStyle}>Nombre del contacto principal *</label>
            <input value={contactoNombre} onChange={(e) => setContactoNombre(e.target.value)} style={inputBase} />

            <label style={{ ...labelStyle, marginTop: 12 }}>Cargo</label>
            <input value={contactoCargo} onChange={(e) => setContactoCargo(e.target.value)} style={inputBase} placeholder="Ej: Gerente General" />

            <label style={{ ...labelStyle, marginTop: 12 }}>Teléfono</label>
            <input value={contactoTel} onChange={(e) => setContactoTel(e.target.value)} style={inputBase} placeholder="55 1234 5678" />

            <label style={{ ...labelStyle, marginTop: 12 }}>Correo</label>
            <input value={contactoCorreo} onChange={(e) => setContactoCorreo(e.target.value)} type="email" style={inputBase} />

            <label style={{ ...labelStyle, marginTop: 12 }}>WhatsApp</label>
            <input value={contactoWA} onChange={(e) => setContactoWA(e.target.value)} style={inputBase} placeholder="5512345678" />

            <label style={{ ...labelStyle, marginTop: 12 }}>Dirección</label>
            <input value={calle} onChange={(e) => setCalle(e.target.value)} style={{ ...inputBase, marginBottom: 6 }} placeholder="Calle y número" />
            <input value={colonia} onChange={(e) => setColonia(e.target.value)} style={{ ...inputBase, marginBottom: 6 }} placeholder="Colonia" />
            <input value={ciudad} onChange={(e) => setCiudad(e.target.value)} style={inputBase} placeholder="Ciudad" />
          </div>
        )}

        {paso === 3 && (
          <div style={{ background: COLOR_FONDO, borderRadius: 12, padding: 16, fontSize: 12, color: COLOR_GRIS, lineHeight: 1.8 }}>
            <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 700, marginBottom: 6 }}>RESUMEN</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: COLOR_OSCURO, marginBottom: 6 }}>{nombre}</div>
            {razonSocial && <div>{razonSocial}</div>}
            <div><strong>Tipo:</strong> {tipo === 'empresa' ? 'Empresa' : 'Persona física'}</div>
            <div><strong>Giro:</strong> {GIROS[giro].label} · {TAMANOS[tamano].label}</div>
            <div><strong>Estado:</strong> {estado}</div>
            <div style={{ marginTop: 8, fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 700 }}>CONTACTO</div>
            <div>{contactoNombre} {contactoCargo && `(${contactoCargo})`}</div>
            {contactoTel && <div>📞 {contactoTel}</div>}
            {contactoCorreo && <div>✉ {contactoCorreo}</div>}
            {(calle || colonia || ciudad) && <div style={{ marginTop: 4 }}>📍 {[calle, colonia, ciudad].filter(Boolean).join(', ')}</div>}
          </div>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          {paso > 1 && (
            <button onClick={() => setPaso(paso - 1)} style={{ flex: 1, padding: 12, background: '#f1f3f6', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
              Atrás
            </button>
          )}
          <button onClick={bor.confirmarCierre(onCerrar)} style={{ flex: 1, padding: 12, background: '#f1f3f6', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
            Cancelar
          </button>
          {paso < 3 ? (
            <button
              onClick={() => setPaso(paso + 1)}
              disabled={paso === 1 ? !puede1 : !puede2}
              style={{
                flex: 1, padding: 12, background: COLOR_PRINCIPAL, color: '#fff',
                border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700,
                cursor: 'pointer', opacity: (paso === 1 ? puede1 : puede2) ? 1 : 0.5,
              }}
            >
              Siguiente →
            </button>
          ) : (
            <button onClick={submit} style={{ flex: 1, padding: 12, background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}>
              Crear cliente
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ============================================
// DETALLE CLIENTE (pantalla)
// ============================================
function DetalleCliente({ cliente, esCelular, onCerrar, onActualizar }) {
  const [tab, setTab] = useState('info');
  const [nuevaNota, setNuevaNota] = useState('');
  const [nuevaSucursal, setNuevaSucursal] = useState({ nombre: '', direccion: '' });

  const giro = GIROS[cliente.giro] || GIROS.otro;
  const estado = ESTADOS[cliente.estado] || ESTADOS.activo;

  const tarjetaCard = { background: '#fff', borderRadius: 14, padding: esCelular ? 14 : 18, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' };
  const inputBase = { padding: '10px 12px', borderRadius: 10, border: '1px solid #d8dde3', fontFamily: PP, fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' };

  const agregarNota = () => {
    if (!nuevaNota.trim()) return;
    onActualizar({ notas: [...(cliente.notas || []), { texto: nuevaNota.trim(), fecha: new Date().toISOString() }] });
    setNuevaNota('');
  };

  const agregarSucursal = () => {
    if (!nuevaSucursal.nombre.trim()) return;
    onActualizar({
      sucursales: [...(cliente.sucursales || []), {
        id: Date.now(), nombre: nuevaSucursal.nombre.trim(), direccion: nuevaSucursal.direccion.trim(),
        contacto: '', telefono: '', equiposInstalados: [], notas: '',
      }],
    });
    setNuevaSucursal({ nombre: '', direccion: '' });
  };

  const tabs = [
    { id: 'info', label: 'Info' },
    { id: 'sucursales', label: 'Sucursales' },
    { id: 'equipos', label: 'Equipos' },
    { id: 'historial', label: 'Historial' },
    { id: 'notas', label: 'Notas' },
  ];

  return (
    <div style={{ fontFamily: PP, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <button
        onClick={onCerrar}
        style={{ alignSelf: 'flex-start', background: 'transparent', border: 'none', color: COLOR_OSCURO, fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: PP }}
      >
        ← Volver a clientes
      </button>

      <div style={{ ...tarjetaCard, display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{
          width: 64, height: 64, borderRadius: '50%',
          background: giro.color, color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 22, fontWeight: 800, flexShrink: 0,
        }}>
          {iniciales(cliente.nombre)}
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, fontWeight: 700 }}>{cliente.folio}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: COLOR_OSCURO }}>{cliente.nombre}</div>
          {cliente.razonSocial && <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO }}>{cliente.razonSocial}</div>}
          <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 11, fontWeight: 700, background: giro.color + '22', color: giro.color, padding: '3px 10px', borderRadius: 12 }}>
              {giro.label}
            </span>
            <span style={{ fontSize: 11, fontWeight: 700, background: estado.bg, color: estado.color, padding: '3px 10px', borderRadius: 12 }}>
              {estado.label}
            </span>
            {cliente.polizaActiva && <span style={{ fontSize: 11, fontWeight: 700, background: '#eaf2fb', color: COLOR_OSCURO, padding: '3px 10px', borderRadius: 12 }}>📜 Póliza</span>}
            {cliente.garantiaActiva && <span style={{ fontSize: 11, fontWeight: 700, background: '#e8faf5', color: '#1D9E75', padding: '3px 10px', borderRadius: 12 }}>🛡️ Garantía</span>}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>Total facturado</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: COLOR_OSCURO }}>
            ${(cliente.montoTotalFacturado || 0).toLocaleString('es-MX', OPC_DINERO)}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              padding: '8px 16px', borderRadius: 12,
              background: tab === t.id ? COLOR_PRINCIPAL : '#fff',
              color: tab === t.id ? '#fff' : COLOR_OSCURO,
              border: `1.5px solid ${COLOR_PRINCIPAL}`,
              fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: PP,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={tarjetaCard}>
        {tab === 'info' && (
          <div style={{ fontSize: 13, color: COLOR_GRIS, lineHeight: 1.8 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 6 }}>DATOS GENERALES</div>
            <div><strong>Tipo:</strong> {cliente.tipo === 'empresa' ? 'Empresa' : 'Persona física'}</div>
            <div><strong>RFC:</strong> {cliente.rfc || '—'}</div>
            <div><strong>Giro:</strong> {GIROS[cliente.giro]?.label}</div>
            <div><strong>Tamaño:</strong> {TAMANOS[cliente.tamano]?.label || '—'}</div>
            <div><strong>Alta:</strong> {fechaCorta(cliente.fechaAlta)}</div>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginTop: 14, marginBottom: 6 }}>CONTACTO PRINCIPAL</div>
            <div>{cliente.contactoPrincipal?.nombre} {cliente.contactoPrincipal?.cargo && `— ${cliente.contactoPrincipal.cargo}`}</div>
            {cliente.contactoPrincipal?.telefono && <div>📞 {cliente.contactoPrincipal.telefono}</div>}
            {cliente.contactoPrincipal?.correo && <div>✉ {cliente.contactoPrincipal.correo}</div>}
            {cliente.contactoPrincipal?.whatsapp && (
              <div>
                <a
                  href={`https://wa.me/52${cliente.contactoPrincipal.whatsapp}`}
                  target="_blank" rel="noopener noreferrer"
                  style={{ color: '#25D366', fontWeight: 700, textDecoration: 'none' }}
                >
                  💬 WhatsApp
                </a>
              </div>
            )}
            {(cliente.direccion?.calle || cliente.direccion?.ciudad) && (
              <>
                <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginTop: 14, marginBottom: 6 }}>DIRECCIÓN</div>
                <div>📍 {[cliente.direccion.calle, cliente.direccion.colonia, cliente.direccion.ciudad].filter(Boolean).join(', ')}</div>
              </>
            )}
          </div>
        )}

        {tab === 'sucursales' && (
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 8 }}>
              SUCURSALES ({cliente.sucursales?.length || 0})
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
              {(cliente.sucursales || []).map(s => (
                <div key={s.id} style={{ padding: 12, background: COLOR_FONDO, borderRadius: 10 }}>
                  <div style={{ fontWeight: 700, color: COLOR_OSCURO, fontSize: 13 }}>🏪 {s.nombre}</div>
                  <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginTop: 2 }}>{s.direccion}</div>
                </div>
              ))}
            </div>
            <div style={{ borderTop: `1px dashed ${COLOR_PRINCIPAL}55`, paddingTop: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 6 }}>+ AGREGAR SUCURSAL</div>
              <input
                value={nuevaSucursal.nombre}
                onChange={(e) => setNuevaSucursal({ ...nuevaSucursal, nombre: e.target.value })}
                placeholder="Nombre de la sucursal"
                style={{ ...inputBase, marginBottom: 6 }}
              />
              <input
                value={nuevaSucursal.direccion}
                onChange={(e) => setNuevaSucursal({ ...nuevaSucursal, direccion: e.target.value })}
                placeholder="Dirección"
                style={{ ...inputBase, marginBottom: 6 }}
              />
              <button
                onClick={agregarSucursal}
                style={{ padding: '10px 16px', background: COLOR_PRINCIPAL, color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}
              >
                Agregar
              </button>
            </div>
          </div>
        )}

        {tab === 'equipos' && (
          <div style={{ textAlign: 'center', padding: 30, color: COLOR_GRIS_CLARO, fontSize: 13 }}>
            {(cliente.equiposInstalados || []).length === 0
              ? '📦 Sin equipos registrados todavía.'
              : `${cliente.equiposInstalados.length} equipos instalados`}
          </div>
        )}

        {tab === 'historial' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 6 }}>SERVICIOS</div>
              {(cliente.serviciosHistorial || []).length === 0
                ? <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO }}>Sin servicios registrados</div>
                : (cliente.serviciosHistorial || []).map((f, i) => <div key={i} style={{ fontSize: 12, color: COLOR_GRIS }}>• {f}</div>)}
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 6 }}>PROYECTOS</div>
              {(cliente.proyectosHistorial || []).length === 0
                ? <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO }}>Sin proyectos registrados</div>
                : (cliente.proyectosHistorial || []).map((f, i) => <div key={i} style={{ fontSize: 12, color: COLOR_GRIS }}>• {f}</div>)}
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 6 }}>COTIZACIONES</div>
              {(cliente.cotizacionesHistorial || []).length === 0
                ? <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO }}>Sin cotizaciones registradas</div>
                : (cliente.cotizacionesHistorial || []).map((f, i) => <div key={i} style={{ fontSize: 12, color: COLOR_GRIS }}>• {f}</div>)}
            </div>
          </div>
        )}

        {tab === 'notas' && (
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLOR_GRIS_CLARO, marginBottom: 8 }}>NOTAS</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
              {(cliente.notas || []).length === 0 ? (
                <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, fontStyle: 'italic' }}>Sin notas todavía</div>
              ) : (cliente.notas || []).map((n, i) => (
                <div key={i} style={{ background: '#eaf2fb', padding: 10, borderRadius: 8, fontSize: 12, color: COLOR_GRIS }}>
                  <div>{n.texto}</div>
                  <div style={{ fontSize: 10, color: COLOR_GRIS_CLARO, marginTop: 2 }}>{new Date(n.fecha).toLocaleString('es-MX')}</div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <input
                value={nuevaNota}
                onChange={(e) => setNuevaNota(e.target.value)}
                placeholder="Agregar nota..."
                style={{ ...inputBase, flex: 1 }}
              />
              <button
                onClick={agregarNota}
                style={{ padding: '10px 16px', background: COLOR_PRINCIPAL, color: '#fff', border: 'none', borderRadius: 10, fontFamily: PP, fontWeight: 700, cursor: 'pointer' }}
              >+</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(20,30,50,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000, padding: 16,
};
const modalCard = {
  background: '#fff', borderRadius: 16, padding: 22,
  width: '100%', maxHeight: 'calc(var(--beep-vh) * 92)', overflowY: 'auto',
  boxShadow: '0 20px 60px rgba(0,0,0,0.25)', fontFamily: PP,
};

export default Clientes;
